<template>
	<v-container fluid fill-height pa-0
		:class="[setClases(), {'companies-route-container': currentRouteName === 'Companies'}]">
		<template v-if="currentRouteName === 'Companies'">
			<FullHeader :headerType="2" />
			<div class="route-view-wrapper">
				<router-view></router-view>
			</div>
		</template>
		<router-view v-else></router-view>
	</v-container>
</template>

<script>
import FullHeader from '@/components/Globals/Headers/FullHeader'

export default {
	name: 'RouterContainer',
	components: {FullHeader},
	computed: {
    currentRouteName() {
        return this.$route.name;
    }
	},
	data: () => ({
		//
	}),
	methods: {
		setClases(){
			let classToAdd = ''
			if(this.$store.menuStore.state.sidebarMini){
				classToAdd += 'mini'
			}
			if(!['Login', 'ResetPassRequest', 'ResetPass', 'NewUserPassword', 'ConfirmUserDelete'].includes(this.currentRouteName)){
				classToAdd += ' router-container'
			}
			if(this.$vuetify.breakpoint.mobile){
				classToAdd += ' mobile'
			}
			return classToAdd
		}
	}
};
</script>
<style scoped>
	.router-container{
		flex: 1;
		width: calc(100% - 240px);
		margin-left: 240px;
		margin-right: 0;
	}
	.router-container.mini{
		width: calc(100% - 56px);
		margin-left: 56px;
	}
	.router-container.mobile{
		width: 100%;
		margin-left: 0;
		margin-right: 0;
	}
	.router-container.mini{
		width: calc(100% - 56px);
		margin-left: 56px;
	}
	.companies-route-container {
		display: flex;
		flex-direction: column;
	}
	.route-view-wrapper {
		flex: 1;
		min-height: 0;
		min-width: 0;
		width: 100%;
	}
</style>
